<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { ModelListSelect } from "vue-search-select";
import PageAlerts from "@/components/page-alerts";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Payment Methods",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    PageAlerts,
    ModelListSelect,
  },
  data() {
    return {
      title: "Payment Methods",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Payment Methods",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "Method Name",
        },
        {
          key: "type_name",
          sortable: true,
          label: "TYPE NAME",
        },
        {
          key: "number",
          sortable: true,
          label: "ACCOUNT NUMBER",
        },
        {
          key: "accounts.acc_name",
          sortable: true,
          label: "ASSET ACCOUNT",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingMode: [],
      nameError: "",
      accountError: "",
      typeError: "",
      typenameError: "",
      assetAccountError: "",
      creditAccountError: "",

      // Value from user input for adding Mode
      data: {
        name: "",
        type: "",
        type_name: "",
        account_number: "",
        assetAccount: "",
        balance: "",
        creditAccount: "",
      },
      // edit Mode
      editdata: {
        name: "",
        type: "",
        type_name: "",
        account_number: "",
        assetAccount: "",
        creditAccount: "",
        id: "",
      },
      // delete Mode
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    ...mapGetters("modes", ["Modes", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("accounts", [
      "getAccounts",
      "getAssetAccounts",
      "getLiabilityAccounts",
      "getEquityAccounts",
      "getRevenueAccounts",
      "getAllTransAccounts",
    ]),
    /**
     * Total no. of records
     */

    rows() {
      return this.Modes ? this.Modes.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Modes ? this.Modes.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchModes: "modes/fetchModes",
      AddPaymentMode: "modes/addMode",
      EditPaymentMode: "modes/editMode",
      DeletePaymentMode: "modes/deleteMode",
      FetchLiabilities: "accounts/fetchLiabilities",
      FetchAssets: "accounts/fetchAssets",
      FetchEquity: "accounts/fetchEquity",
      FetchRevenue: "accounts/fetchRevenue",
      FetchTransAccounts: "accounts/fetchTransAccounts",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (
        this.data.name != "" &&
        this.data.type != "" &&
        this.data.type_name != ""
      ) {
        this.existingMode = this.Modes.filter((PaymentMode) => {
          return (
            PaymentMode.name.toUpperCase() == this.data.name.toUpperCase() &&
            PaymentMode.type.toUpperCase() == this.data.type.toUpperCase() &&
            PaymentMode.type_name.toUpperCase() ==
              this.data.type_name.toUpperCase()
          );
        });
        if (this.existingMode.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingMode = [];
      }
    },

    addPaymentMode(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Payment Mode name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.type === "") {
        this.typeError = "Payment Mode Type field is required";
        return;
      } else {
        this.typeError = "";
      }
      if (this.data.type_name === "") {
        this.typenameError = "Payment Mode Type Name field is required";
        return;
      } else {
        this.typenameError = "";
      }
      if (this.data.account_number === "") {
        this.accountError = "Payment Mode Account Number field is required";
        return;
      } else {
        this.accountError = "";
      }
      if (this.data.assetAccount === "") {
        this.assetAccountError = "Asset Account field is required";
        return;
      } else {
        this.assetAccountError = "";
      }
      if (
        this.data.balance !== "" &&
        this.data.balance != 0 &&
        this.data.creditAccount === ""
      ) {
        this.creditAccountError = "Credit Account field is required";
        return;
      } else {
        this.creditAccountError = "";
      }
      if (this.existingMode.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      if (this.data.assetAccount == this.data.creditAccount) {
        this.creditAccountError =
          "Credit account should be different from Debit Account";
        return;
      } else {
        this.creditAccountError = "";
      }

      this.AddPaymentMode(this.data);
    },

    resetAddCat() {
      this.data.name = "";
      this.data.type = "";
      this.data.type_name = "";
      this.data.account_number = "";
      this.data.balance = "";
      this.data.assetAccount = "";
      this.data.creditAccount = "";
      this.nameError = "";
      this.nameError = "";
      this.accountError = "";
      this.assetAccountError = "";
      this.typeError = "";
      this.typenameError = "";
      this.modal_id = "";
    },
    resetEditCat() {
      this.editdata.name = "";
      this.editdata.type = "";
      this.editdata.type_name = "";
      this.editdata.account_number = "";
      this.editdata.assetAccount = "";
      this.editdata.creditAccount = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDeleteCat() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetDefault() {
      this.defaultMode.name = "";
      this.defaultMode.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.accountError = "";
      this.assetAccountError = "";
      this.creditAccountError = "";
      this.typeError = "";
      this.typenameError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.name;
      this.editdata.type = data.item.type;
      this.editdata.type_name = data.item.type_name;
      this.editdata.account_number = data.item.number;
      this.assetAccount = data.item.accounts ? data.item.accounts.id : "";
      this.editdata.id = data.item.id;
    },
    editPaymentMode(modalId) {
      this.modal_id = modalId;
      this.EditPaymentMode(this.editdata);
      this.closeModal("edit-option-modal");
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },
    showDefaultModal(data) {
      this.defaultMode.name = data.item.name;
      this.defaultMode.id = data.item.id;
    },
    deletePaymentMode(modalId) {
      this.modal_id = modalId;
      this.DeletePaymentMode(this.deletedata);
    },
    changeDefault(modelId) {
      this.modal_id = modelId;
      this.DefaultPaymentMode(this.defaultOption);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    redirect(value) {
      this.$router.push(`/modes/statement/${btoa(value)}`);
    },
  },
  created() {
    this.FetchModes();
    this.FetchAssets();
    this.FetchTransAccounts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_payment_method')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Payment Methods</h4>
              </div>
              <div class="col-md-3" align="right">
                <b-button
                  v-b-modal.add-option-modal
                  variant="primary"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_payment_method')
                    )
                  "
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Modes ? Modes : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="info"
                      @click="redirect(data.item.id)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('view_method_statement')
                        )
                      "
                      ><i class="fa fa-eye"></i> Statement</b-button
                    >
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-option-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_payment_method')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-option-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_payment_method')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal starts -->
      <b-modal
        id="add-option-modal"
        size="lg"
        hide-footer
        @hidden="resetAddCat"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_payment_method')
          )
        "
      >
        <template #modal-title> Add New Payment Method </template>
        <div class="card-body row">
          <div class="form-group col-md-6 mb-2">
            <label>Type</label>
            <select
              class="form-control"
              v-model="data.type"
              @keyup="checkName()"
            >
              <option value="" selected disabled>Select</option>
              <option value="mobile">Mobile Money</option>
              <option value="bank">Bank</option>
              <option value="cash">Cash</option>
              <option value="onlinePayment">Online Payment</option>
            </select>
            <div class="text-danger" v-if="typeError">
              <em>{{ typeError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Registered Names</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Names"
                class="form-control"
                @keyup="checkName"
                @input="resetError()"
                v-model="data.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Type Name</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="e.g. MTN, Airtel, Stambic, Centenary etc"
                class="form-control"
                @keyup="checkName"
                @input="resetError()"
                v-model="data.type_name"
              />
            </div>
            <div class="text-danger" v-if="typenameError">
              <em>{{ typenameError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Account Number</label>
            <div class="input-group">
              <input
                type="number"
                placeholder="Enter Account Number"
                class="form-control"
                v-model="data.account_number"
                @keyup="checkName()"
                @input="resetError()"
              />
            </div>
            <div class="text-danger" v-if="accountError">
              <em>{{ accountError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Current Balance</label>
            <div class="input-group">
              <input
                type="number"
                @keyup="checkName()"
                placeholder="Enter Current Balance on the Account"
                class="form-control"
                v-model="data.balance"
              />
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Select Debit Account</label>
            <model-list-select
              required
              :list="getAssetAccounts ? getAssetAccounts : []"
              v-model="data.assetAccount"
              option-value="id"
              option-text="full_name"
              class="mb-2"
              placeholder="Select Account"
            >
            </model-list-select>
            <div class="text-danger" v-if="assetAccountError">
              <em>{{ assetAccountError }}</em>
            </div>
          </div>
          <div
            class="form-group col-md-6 mb-2"
            v-if="data.balance && data.balance != 0"
          >
            <label>Select Credit Account</label>
            <model-list-select
              required
              :list="
                getAllTransAccounts ? getAllTransAccounts.except_expense : []
              "
              v-model="data.creditAccount"
              option-value="id"
              option-text="full_name"
              class="mb-2"
              placeholder="Select Account"
            >
            </model-list-select>
            <div class="text-danger" v-if="creditAccountError">
              <em>{{ creditAccountError }}</em>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-option-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addPaymentMode('add-option-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-option-modal"
        size="lg"
        hide-footer
        @hidden="resetEditCat"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_payment_method')
          )
        "
      >
        <template #modal-title> Edit Option {{ editdata.name }}</template>
        <div class="card-body row">
          <div class="form-group col-md-6 mb-2">
            <label>Type</label>
            <select
              class="form-control"
              v-model="editdata.type"
              @keyup="checkName()"
            >
              <option value="" selected disabled>Select</option>
              <option value="mobile">Mobile Money</option>
              <option value="bank">Bank</option>
              <option value="cash">Cash</option>
              <option value="onlinePayment">Online Payment</option>
            </select>
            <div class="text-danger" v-if="typeError">
              <em>{{ typeError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Registered Names</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Option Name"
                class="form-control"
                @keyup="checkName"
                @input="resetError()"
                v-model="editdata.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Type Name</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Type Name"
                class="form-control"
                @keyup="checkName"
                @input="resetError()"
                v-model="editdata.type_name"
              />
            </div>
            <div class="text-danger" v-if="typenameError">
              <em>{{ typenameError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Account Number</label>
            <div class="input-group">
              <input
                type="number"
                placeholder="Enter Account Number"
                class="form-control"
                v-model="editdata.account_number"
                @keyup="checkName()"
                @input="resetError()"
              />
              <div class="text-danger" v-if="accountError">
                <em>{{ accountError }}</em>
              </div>
            </div>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label>Select Asset account</label>
            <model-list-select
              required
              :list="getAssetAccounts ? getAssetAccounts : []"
              v-model="editdata.assetAccount"
              option-value="id"
              option-text="full_name"
              class="mb-2"
              placeholder="Select Account"
            >
            </model-list-select>
            <div class="text-danger" v-if="assetAccountError">
              <em>{{ assetAccountError }}</em>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-option-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editPaymentMode('edit-option-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Saving"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete option starts -->
      <b-modal
        header-bg-variant="danger"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="danger"
        footer-text-variant="danger"
        id="delete-option-modal"
        hide-footer
        @hidden="resetDeleteCat"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_payment_method')
          )
        "
      >
        <template #modal-title>
          <span class="text-white"
            >Delete Payment Method {{ deletedata.name }}</span
          >
        </template>
        <div class="form-group mb-2">
          <div class="input-group">
            <PageAlerts
              title="CAUTION!!!"
              primaryMsg="I you delete a payment mode with transations, Its transactions will still stay in the system. You can edit it instead."
              alertType="danger"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-option-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger"
            @click="deletePaymentMode('delete-option-modal')"
          >
            <i class="fa fa-trash"></i> Proceed
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
